import Backbone from 'backbone'
import template from './selected-item-info.hbs'
import i18n from 'scoreboard/components/i18n'


const SelectedItemInfo = Backbone.View.extend({
	className: 'selected-item-info',

	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		this.$el.empty().append(template(this.context()))
		return this
	},

	context: function () {
		let numDestinationItems = this.options.numDestinationItems || 0
		let numSourceItems = this.options.numSourceItems || 0
		let difference = numSourceItems - numDestinationItems
		let missing
		if (difference >= 0) {
			missing = i18n.get('admin.import.destinationItems.missing', difference)
		}
		let type = this.options.type
		let icon, pluralKey, countKey, editKey
		if (type === 'initiative-status') {
			icon = 'initiative'
			pluralKey = 'initiatives.initiatives'
			countKey = 'initiatives.initiatives.number'
			editKey = 'admin.import.selectItems.edit.initiative'
		} else {
			icon = 'metric'
			pluralKey = 'scorecards.metrics.metrics'
			countKey = 'scorecards.node.metric.number'
			editKey = 'admin.import.selectItems.edit.metric'
		}
		let pluralItem = i18n.get(pluralKey)
		return {
			destinationItemsLabel: i18n.get('admin.import.destinationItems', pluralItem),
			sourceItemsLabel: i18n.get('admin.import.destinationItems.sourceItems', pluralItem),
			destinationItems: i18n.countMessage(countKey, numDestinationItems),
			sourceItems: i18n.countMessage(countKey, numSourceItems),
			missing,
			icon,
			showEditButton: this.options.showEditButton,
			editButtonLabel: i18n.countMessage(editKey, numDestinationItems)
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})
export default SelectedItemInfo



SelectedItemInfo.__filename__ = 'imports/vi/selected-item-info.js'
